import React, {useState, useEffect} from 'react';
import moment from 'moment';
import {useSelector, useDispatch} from 'react-redux';
import {useSearchParams} from 'react-router-dom';
import {groupBy, values} from 'lodash';
import DatePicker from 'react-datepicker';
import {Grid, Card, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {dateFormatReservation} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import ModalComponent from './Modal';
import '../style.scss';

const {withRouter, calendarDetailList, calendarUpdateDaTe} = Actions;

const CustomCalendar = ({items, month, year, onDateUpdate}) => {
  const filterDays = [];
  const filterOffDays = [];
  items.forEach((months) => {
    months.forEach((day) => {
      if (day.working === 'S') {
        filterDays.push(moment(day.date).toDate());
      } else {
        filterOffDays.push(moment(day.date).toDate());
      }
    });
  });

  
  const highlightWithRanges = [
    {
      'react-datepicker__day--selected': filterOffDays,
    },
  ];
  return (
    <div className='customDatePickerWidth'>
      {(month && year) && <DatePicker
        inline
        minDate={moment(`${month}/01/${year}`).startOf('year').toDate()}
        maxDate={moment(`${month}/01/${year}`).endOf('year').toDate()}
        selected={moment(`${month}/01/${year}`).toDate()}
        highlightDates={highlightWithRanges}
        onChange={(date) => onDateUpdate(date)}
        monthsShown={3}
        locale='es'
      />}
    </div>
  );
};

const TdeCalendarDetail = ({history}) => {
  const [open, setOpen] = useState(false);
  const [dateSelect, setDateSelect] = useState(null);
  const [searchParams] = useSearchParams();
  const permissions = useSelector((state) => state.session.permissions);
  const listCalendarDetail = useSelector((state) => state.listCalendarDetail);
  const dispatch = useDispatch();
  const {list, loading, month, year, area} = listCalendarDetail;

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.TdeCalendarDetail, scopes.See)) {
      history.push(paths.AccessDenied);
    }
    dispatch(calendarDetailList(searchParams.toString()));
  }, [dispatch]);

  const onClose = () => {
    setOpen(false);
  };

  const onCancelClick = () => {
    history.push(paths.TdeCalendar);
  };

  const groupData = () => {
    const groupByName = groupBy(list, 'monthName');
    return values(groupByName);
  };

  const onDateUpdate = (date) => {
    const parseDate = moment(date).format(dateFormatReservation);
    dispatch(calendarUpdateDaTe(parseDate, searchParams.toString(), area));
    setDateSelect(parseDate);
    setOpen(false);
  };

  if (loading) {
    return <h1>Cargando</h1>;
  }

  return (
    <div>
      <Card raised fluid>
        <Grid columns={3} padded>
          <Grid.Row>
            <Grid.Column verticalAlign='middle'>
              <Icon name='arrow left' size='big' onClick={onCancelClick} />
            </Grid.Column>
            <Grid.Column>
              <h1>Calendario de {area} </h1>
            </Grid.Column>
            <Grid.Column></Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
      <CustomCalendar
        items={groupData(list)}
        month={month}
        year={year}
        onDateUpdate={onDateUpdate}
      />
      {open && (
        <ModalComponent
          open={open}
          onClose={onClose}
          dateSelect={dateSelect}
          calendarUpdateDaTe={onDateUpdate}
        />
      )}
    </div>
  );
};

export default withRouter(TdeCalendarDetail);
